import React, { Component } from "react";
import AdditionalProcessForm from "../AdditionalProcessForm/AdditionalProcessForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AdditionalProcessPage
Description : Componente que contienen el formulario de la pantalla AdditionalProcess 
Date Autor Modification
================================================================================
06/10/2023 Santiago Coca – Se llama al componente AdditionalProcess
================================================================================ */
class AdditionalProcessPage extends Component {
    render() {
        return (
            <div>
                <AdditionalProcessForm />
            </div>
        )
    }
}

export default AdditionalProcessPage;